import * as React from 'react'

import { defaultErrorProps } from 'components/error-props'

import { NextPage, withErrorPage, withScridId } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { InitialProps, Page, Props } from '@grandvisionhq/www-next/pages/cancel-appointment'

import { withCms, withLayout } from '../cms'
import { cancellationReasons } from '../configuration/cancellation-reasons'

import '@grandvisionhq/appointments/dist/index.css'

const CancelAppointment: NextPage<Props, InitialProps> = ({ ...props }) => {
  return <Page {...props} cancellationReasons={cancellationReasons} />
}

CancelAppointment.getInitialProps = Page.getInitialProps

export default compose<Props, Props>(
  withCms(),
  withErrorPage(defaultErrorProps),
  withLayout({
    hasOnlyLogoInHeader: true,
    footer: false,
  }),
  withScridId()
)(CancelAppointment)
